// extracted by mini-css-extract-plugin
export default {"select":"Select_select__pH3MZ","dark-mode":"Select_dark-mode__pkqQZ","disabled":"Select_disabled__3xFGU"};